import { memo } from 'react';

import { groupBy } from 'remeda';

import { PARTNER_SPOTLIGHT_STATUSES_ORDER } from './DraggablePartnerSpotlightCards.contants';
import { PartnerSpotlightStatusGroup } from './partnerSpotlightStatusGroup/PartnerSpotlightStatusGroup';

import css from './DraggablePartnerSpotlightCards.module.css';

import { PartnerSpotlightModel } from 'v2/types/PartnerSpotlightModel';

interface DraggablePartnerSpotlightCardsProps {
  partnerSpotlights: PartnerSpotlightModel[];
  onRevalidate: VoidFunction;
  dragDisabled: boolean;
  hideEmptyGroups: boolean;
}

export const DraggablePartnerSpotlightCards = memo<DraggablePartnerSpotlightCardsProps>(
  ({ partnerSpotlights, onRevalidate, dragDisabled, hideEmptyGroups }) => {
    const groupedByStatus = groupBy(partnerSpotlights, (item) => item.status);

    return (
      <div className={css.draggablePartnerSpotlightCards}>
        {PARTNER_SPOTLIGHT_STATUSES_ORDER.map((status) => (
          <PartnerSpotlightStatusGroup
            key={status}
            status={status}
            partnerSpotlights={groupedByStatus[status] ?? []}
            onRevalidate={onRevalidate}
            dragDisabled={dragDisabled}
            hideWhenEmpty={hideEmptyGroups}
          />
        ))}
      </div>
    );
  }
);

DraggablePartnerSpotlightCards.displayName = 'DraggablePartnerSpotlightCards';
